import { z } from "zod";

export const loginBodySchema = z.object({
  username: z.string(),
  password: z.string(),
});

export type TLoginBody = z.infer<typeof loginBodySchema>;
